import React, { Component } from "react"
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import moment from '../../utils/helpers/moment'
import share_apple_img from '../../utils/assets/images/share-apple.png'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'
import { fetchSouscripteurAction } from '../../actions/Souscription/Souscripteur'
import { SERVER_URL } from '../../utils/helpers/constanteData'

import {
  fetchReauthenticateCourtiersAction
} from  '../../actions/Authentification/ReauthenticateCourtiers'

class ValidationSouscripteur extends Component {
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier"),
  }
  componentDidMount() {
    document.title = `Dashboard Membre | Validation de la souscription`

    const { isCurrentLoginCourtier } = this.state
    const { getReauthenticate, reauthenticateMembers, reauthenticateCourtiers, getReauthenticateCourtiers, userGetSouscripteur } = this.props
    
    if (isCurrentLoginCourtier) {
      if (Object.keys(reauthenticateCourtiers.courtierData).length === 0) {
        getReauthenticateCourtiers()
      }
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }else {
      if (Object.keys(reauthenticateMembers.userData).length === 0) {
        getReauthenticate()
      }
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const { reauthenticateMembers, reauthenticateCourtiers, userGetSouscripteur } = nextProps

    if (reauthenticateMembers.userData.length !== this.props.reauthenticateMembers.userData.length) {
      if (reauthenticateMembers.userData.souscripteurID) {
        userGetSouscripteur(reauthenticateMembers.userData.souscripteurID)
      }
    }
    if (reauthenticateCourtiers.courtierData.length !== this.props.reauthenticateCourtiers.courtierData.length) {
      if (reauthenticateCourtiers.courtierData.souscripteurID) {
        userGetSouscripteur(reauthenticateCourtiers.courtierData.souscripteurID)
      }
    }
  }
  render() {
    const { match, reauthenticateMembers, reauthenticateCourtiers, getSouscripteur } = this.props
    const { isCurrentLoginCourtier } = this.state
    
    return (
      <div>
        <Header userIsSuccessLogin={isCurrentLoginCourtier ? reauthenticateCourtiers.isSuccess : reauthenticateMembers.isSuccess} />
          {(reauthenticateMembers.isLoading || reauthenticateCourtiers.isLoading)
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-body-second-stats-content aps-dashboard-body-second-validation-souscription">
                  <h1 className="uk-text-center aps-dashboard-body-stats-title">
                    Bonjour {isCurrentLoginCourtier ? reauthenticateCourtiers.courtierData.companyName : `${reauthenticateMembers.userData.lastname} ${reauthenticateMembers.userData.lastname}`} !
                  </h1>
                  {isCurrentLoginCourtier
                    ?
                      <div className="uk-text-center aps-section-parrain-content-dashboard" style={{paddingTop: "15px", paddingLeft: "0px", paddingRight: "0px"}}>
                        La police d'assurance SƆHU de votre votre client {getSouscripteur.souscripteurData.lastname} {getSouscripteur.souscripteurData.firstname} est désormais activée.
                      </div>
                    :
                      <div className="uk-text-center aps-section-parrain-content-dashboard" style={{paddingTop: "15px", paddingLeft: "0px", paddingRight: "0px"}}>
                        Votre police d’assurance SƆHU est désormais activée.
                      </div>
                  }
                  {getSouscripteur.isLoading
                    ?
                      <div className="aps-spinner-component-loading">
                        <div className="uk-spinner">
                          <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                             <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                          </svg>
                        </div>
                        <div className="aps-section-register-desc">chargement en cours</div>
                      </div>
                    :
                      <div>
                        <div className="uk-grid" data-uk-grid>
                          <div className="uk-width-1-2@m aps-dashboard-body-stats-card-margin aps-dashboard-validation-police-apply-date">
                            <div className="aps-dashboard-body-stats-card uk-card uk-card-default uk-card-small uk-card-body aps-dashboard-body-stats-card-first" style={{backgroundColor: "#ACC043"}}>
                              <div className="uk-card-title uk-flex uk-flex-between">
                                <h3 className="aps-dashboard-body-validation-souscription-card-title">Date d’effet :</h3>
                                <span className="aps-dashboard-body-white-arrow" data-uk-icon="icon: calendar; ratio: 1.7"></span>
                              </div>
                              <p className="aps-dashboard-body-validation-souscription-card-content">
                                {getSouscripteur.souscripteurData.startDate && moment(getSouscripteur.souscripteurData.startDate).format("Do MMMM YYYY")}
                              </p>
                            </div>
                          </div>
                          <div className="uk-width-1-2@m aps-dashboard-body-stats-card-margin aps-dashboard-validation-police-apply-date" style={{paddingLeft: "20px"}}>
                            <div className="aps-dashboard-body-stats-card uk-card uk-card-default uk-card-small uk-card-body aps-dashboard-body-stats-card-first" style={{backgroundColor: "#E49D42"}}>
                              <div className="uk-card-title uk-flex uk-flex-between">
                                <h3 className="aps-dashboard-body-validation-souscription-card-title">Date d’écheance :</h3>
                                <span className="aps-dashboard-body-white-arrow" data-uk-icon="icon: calendar; ratio: 1.7"></span>
                              </div>
                              <p className="aps-dashboard-body-validation-souscription-card-content">
                                {getSouscripteur.souscripteurData.endDate && moment(getSouscripteur.souscripteurData.endDate).format("Do MMMM YYYY")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                  }
                </div>
                {getSouscripteur.isLoading
                  ?
                    <div className="aps-spinner-component-loading">
                      <div className="uk-spinner">
                        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                           <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="8"></circle>
                        </svg>
                      </div>
                      <div className="aps-section-register-desc">chargement en cours</div>
                    </div>
                  :
                    <div>
                      <div className="aps-dashboard-body-divider"></div>
                      <div className="aps-dashboard-body-second-reglement-content">
                        <Link className="aps-section-status-content-full-lien" target="_blank" to={`${SERVER_URL}/dossier/${getSouscripteur.souscripteurData._id}`}>
                          <div className="uk-card-hover">
                            <p className="aps-section-status-padding-left " style={{margin: "0"}}>
                              <img className="aps-section-status-share-apple" src={share_apple_img} alt="fi-alert" />
                              <span className="aps-section-status-content-full">
                                Mon dossier de souscription
                              </span>
                            </p>
                          </div>
                        </Link>
                      </div>
                      <div className="aps-dashboard-body-divider"></div>
                      <div className="aps-dashboard-body-second-reglement-content">
                        <Link className="aps-section-status-content-full-lien" target="_blank" to={`${SERVER_URL}/downloads/${getSouscripteur.souscripteurData.cardFile}`}>
                          <div className="uk-card-hover">
                            <p className="aps-section-status-padding-left " style={{margin: "0"}}>
                              <img className="aps-section-status-share-apple" src={share_apple_img} alt="fi-alert" />
                              <span className="aps-section-status-content-full">
                                Mon certificat d&apos;assurance
                              </span>
                            </p>
                          </div>
                        </Link>
                      </div>
                      <div className="aps-dashboard-body-divider"></div>
                      <div className="aps-dashboard-body-second-reglement-content">
                        <Link className="aps-section-status-content-full-lien" target="_blank" to={`${SERVER_URL}/downloads/${getSouscripteur.souscripteurData.conditionsFile}`}>
                          <div className="uk-card-hover">
                            <p className="aps-section-status-padding-left " style={{margin: "0"}}>
                              <img className="aps-section-status-share-apple" src={share_apple_img} alt="fi-alert" />
                              <span className="aps-section-status-content-full">
                                Mon welcome pack SƆHU
                              </span>
                            </p>
                          </div>
                        </Link>
                      </div>
                      <div className="aps-dashboard-body-divider"></div>
                      <div className="aps-dashboard-body-second-reglement-content">
                        <Link className="aps-section-status-content-full-lien" target="_blank" to={`${SERVER_URL}/downloads/${getSouscripteur.souscripteurData.lastCallContributionFile}`}>
                          <div className="uk-card-hover">
                            <p className="aps-section-status-padding-left " style={{margin: "0"}}>
                              <img className="aps-section-status-share-apple" src={share_apple_img} alt="fi-alert" />
                              <span className="aps-section-status-content-full">
                                Mon dernier appel de cotisation
                              </span>
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                }
                {(reauthenticateMembers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion' push/>
                  </div>
                }
                {(reauthenticateCourtiers.isError && !isCurrentLoginCourtier) &&
                  <div>
                    <Redirect to='/connexion-intermediaires' push/>
                  </div>
                }
              </Dashboard>
            }
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = ({ reauthenticateMembers, reauthenticateCourtiers, getSouscripteur }) => {
  return {
    reauthenticateMembers,
    reauthenticateCourtiers,
    getSouscripteur,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
    getReauthenticateCourtiers: () => dispatch(fetchReauthenticateCourtiersAction()),
    userGetSouscripteur: (souscripteurID) => dispatch(fetchSouscripteurAction(souscripteurID)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ValidationSouscripteur)



// WEBPACK FOOTER //
// ./src/containers/ValidationSouscripteur/index.js